export interface Codespace {
  id: string
  created_timestamp: Date
  modified_timestamp: Date
  codespace_id: string
  description: string
}

export interface FetchCodespaceListParams {
  bypass_pagination?: boolean
  sort_by?: string
  sort_order?: string
  start_index?: string
  count?: number
}

export enum CodespaceTabType {
  DETAILS = 'details'
}
